import React from 'react';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { Dialog, useMediaQuery } from '@mui/material';
import { PaperComponent } from '../PaperComponent';

// /////////////////////////////////////////////////////////////////////////////////////////////////
const CommonSwipeableDrawer = ({
  anchor = 'bottom',
  open = false,
  onOpen = () => {},
  onClose = () => {},
  children,
  width = '100%',
  maxHeight = '50%',
  height = '100%',
  minHeight = '25%',
}) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
  if (isMobile) {
    return (
      <SwipeableDrawer
        anchor={anchor}
        open={open}
        onClose={onClose}
        onOpen={onOpen}
        sx={{
          height: '0%',
          '& .MuiDrawer-paper': {
            width: '100%',
            borderTopRightRadius: anchor === 'bottom' ? '16px' : '0px',
            borderTopLeftRadius: anchor === 'bottom' ? '16px' : '0px',
            minHeight: minHeight,
            maxHeight: maxHeight,
            height: height,
          },
        }}
      >
        {children}
      </SwipeableDrawer>
    );
  }

  return (
    <Dialog
      open={open}
      PaperComponent={PaperComponent}
      aria-labelledby='draggable-dialog-title'
      sx={{ '& .MuiPaper-root': { borderRadius: '10px', height: '714px', width: '480px' } }}
    >
      {children}
    </Dialog>
  );
};

export default CommonSwipeableDrawer;
